module.exports = __webpack_public_path__ + "static/media/partitions_allImpact_10y_y.f441c142.csv";